import {DeliveryEstimates} from '../types';

export function hasFasterOptions(
  deliveryEstimates: DeliveryEstimates | null | undefined,
): boolean {
  // eslint-disable-next-line id-length
  const compareDates = (a: Date | string | null, b: Date | string | null) => {
    if (!a || !b) {
      return false;
    }

    return (
      (a instanceof Date ? a : new Date(a)) <
      (b instanceof Date ? b : new Date(b))
    );
  };

  const selectedDeliveryTime =
    deliveryEstimates?.selectedShippingOption?.maxDeliveryTime;

  if (!selectedDeliveryTime) {
    return false;
  }

  return (
    (deliveryEstimates?.options ?? []).filter(
      ({maxDeliveryTime}) =>
        maxDeliveryTime &&
        compareDates(maxDeliveryTime, selectedDeliveryTime) &&
        compareDates(new Date(), maxDeliveryTime),
    ).length > 0 || false
  );
}
